var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.07 13.06C19.17 12.72 19.24 12.37 19.24 12C19.24 11.63 19.17 11.28 19.07 10.94L21.35 9.88C21.55 9.78 21.61 9.53 21.5 9.33L19.46 5.89C19.35 5.69 19.1 5.63 18.9 5.73L16.29 6.79C15.67 6.38 14.98 6.06 14.25 5.86L13.83 3.06C13.79 2.85 13.6 2.7 13.39 2.7H10.61C10.4 2.7 10.21 2.85 10.17 3.06L9.75 5.86C9.02 6.06 8.33 6.38 7.71 6.79L5.1 5.73C4.9 5.63 4.65 5.69 4.54 5.89L2.5 9.33C2.39 9.53 2.45 9.78 2.65 9.88L4.93 10.94C4.83 11.28 4.76 11.63 4.76 12C4.76 12.37 4.83 12.72 4.93 13.06L2.65 14.12C2.45 14.22 2.39 14.47 2.5 14.67L4.54 18.11C4.65 18.31 4.9 18.37 5.1 18.27L7.71 17.21C8.33 17.62 9.02 17.94 9.75 18.14L10.17 20.94C10.21 21.15 10.4 21.3 10.61 21.3H13.39C13.6 21.3 13.79 21.15 13.83 20.94L14.25 18.14C14.98 17.94 15.67 17.62 16.29 17.21L18.9 18.27C19.1 18.37 19.35 18.31 19.46 18.11L21.5 14.67C21.61 14.47 21.55 14.22 21.35 14.12L19.07 13.06Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.589d5488d460a29d5bc8fa2520c0937a.svg";
export { ForwardRef as ReactComponent };